module.exports = __webpack_public_path__ + "static/media/present.e3eafa83.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/present.glb
// module id = 93
// module chunks = 0